module.exports = __webpack_public_path__ + "static/media/website_sm.266a7514ba19f62a2ce09797e7fe79c3.svg";